<template>
  <div id="creprjlog"></div>
</template>
  
  <script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

export default {
  name: "creprjlog",
  data() {
    return {
      db: firebase.firestore(),
    };
  },
  computed: {
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
  },
  methods: {
    creprjlog: async function(lidid,prjid,title) {
      // ログの記録
      let collection = this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(this.uid)
        .collection("creprjlog");
      collection
        .add({
          creprj: true,
          lidid: lidid,
          prjid: prjid,
          title: title,
          date: firebase.firestore.Timestamp.now(),
        })
        .then(function () {})
        .catch(function (error) {
          console.error("ログの記入でエラーが発生しました。", error);
        });
      // アクティビティカウンターの増加
      let counterdoc = this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(this.uid)
        .collection("counter")
        .doc("counter");
      counterdoc.set(
        {
          isActive: true,
          lastupdate: firebase.firestore.Timestamp.now()
        },
        { merge: true }
      );
      counterdoc.update({
        creprj_all: firebase.firestore.FieldValue.increment(1),
      });
    },
  },
  created() {},
};
</script>
        